<template>
  <div class="mt-0 text-base">
    <div>
      <div class="pb-6 text-center">
        <h1 class="text-ontick-steel-900 text-2xl font-semibold dark:text-gray-200">
          <span>
            {{ order.info.alg_ord_name }}
          </span>
          <span class="text-sm font-semibold text-gray-400">
            ID: {{ order.info.alg_ord_id || order.info.trail_order_id }}
          </span>
        </h1>
        <p class="font-regular text-ontick-steel-700 text-sm dark:text-gray-300">
          Ativos operados: {{ order.orders[0].trail_order_symbol }} |
          {{ order.orders[1].trail_order_symbol }}
        </p>
      </div>
      <div class="flex items-center justify-center space-x-2 pb-6">
        <ontick-broker-logo-component :broker="getSelectedAccount.broker_name" />
        <p class="text-ontick-steel-900 text-lg font-semibold dark:text-gray-200">
          {{ getSelectedAccount.broker_name }}
        </p>
        <p class="text-ontick-steel-400 text-lg font-medium dark:text-gray-400">
          (#{{ getSelectedAccount.account_number }})
        </p>
        <ontick-account-type-badge-component :accountType="getSelectedAccount.account_type" />
      </div>
    </div>
    <div
      class="space-y-6"
      style="visibility: inherit; opacity: 1; transform: matrix(1, 0, 0, 1, 0, 0); transform-origin: 50% 50% 0px"
    >
      <!----><!---->
      <div>
        <p class="text-ontick-carbon-900 mb-6 text-center text-xl font-medium dark:text-gray-200">Parar operação</p>
        <div class="text-ontick-carbon-900 dark:text-ontick-graphite-300 mx-auto mb-6 w-11/12 sm:w-5/6 md:w-4/6">
          <p class="flex">
            <span class="text-ontick-green-500 pr-2"
              ><svg
                class="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </span>
            Todas as posições abertas serão fechadas.
          </p>
          <p class="flex">
            <span class="text-ontick-green-500 pr-2"
              ><svg
                class="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </span>
            Todas as ordens pendentes serão canceladas.
          </p>
        </div>
        <p class="text-ontick-steel-900 text-center text-sm dark:text-gray-300">
          Você está prestes a desligar esta operação
        </p>
        <!---->
      </div>
      <!----><!---->
      <div class="space-y-6 py-1 text-center md:py-6">
        <ontick-button color="red" @click.native="stopOrder">
          <span class="font-bold uppercase"> Parar operação </span>
        </ontick-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OntickAccountTypeBadgeComponent from "../../../shared/components/basic/ontick-account-type-badge.component.vue";
import ontickBrokerLogoComponent from "../../../shared/components/basic/ontick-broker-logo.component.vue";
import event_bus from "../../../shared/utils/event_bus";
export default {
  components: {
    OntickAccountTypeBadgeComponent,
    ontickBrokerLogoComponent,
  },
  props: {
    order: {
      type: Object,
    },
  },

  computed: {
    ...mapGetters({ getSelectedAccount: "accountTypes/getSelectedAccount" }),
  },

  methods: {
    stopOrder() {
      const trail_order_id = this.order.orders[0].trail_order_id;
      return this.$api
        .post(this.$endpoint.STOP_TRAIL_ORDER, {
          trail_order_id,
          account_id: this.getSelectedAccount.account_id,
        })
        .then((res) => {
          // console.log(res);
          this.$swal("Operação parada", res.data.msg, "success");
          // this.reload();
        })
        .catch((err) => {
          console.error(err);
          this.$swal("Erro", err.data.msg, "error");
        })
        .finally(() => {
          event_bus.$emit("RELOAD_ALGO_ORDERS");
          this.$emit("close");
        });
    },
  },
};
</script>

<style></style>
